import { Component } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NavParams } from 'ionic-angular';
import { NavController } from 'ionic-angular';
//import { Http } from '@angular/http';

@Component({
    selector: 'page-auftraege',
    templateUrl: 'auftraege.html'
  })
  export class AuftraegePage {
    driverId: string;
    companyId: string;
    auftraege: any[] = [];
    datenGeladen: boolean = false;
  
    constructor(public navParams: NavParams, public http: HttpClient, public navCtrl: NavController) {
      this.driverId = this.navParams.get('driver_id');
      this.companyId = this.navParams.get('company_id');
  
      this.ladeAuftraege();
    }
  
    ladeAuftraege() {
    const params = new HttpParams()
    .set('driver_id', this.driverId)
    .set('company_id', this.companyId);

  this.http.get('https://api.fahrdienstpro.de/takeoff_api/tagesplan.php', { params })
    .toPromise()
    .then((response: any) => {
      if (response && response.status === 'true') {
        this.auftraege = response.response;
        this.datenGeladen = true;
      } else {
        this.auftraege = [];
        this.datenGeladen = false;
      }
    })
    .catch(error => {
      console.error('Fehler beim Laden der Daten:', error);
      this.auftraege = [];
      this.datenGeladen = false;
    });
    }

    goBack() {
        this.navCtrl.pop();
      }
    exportCSV() {
        let csvContent = 'data:text/csv;charset=utf-8,';
        const headers = ['Standort','Datum','Uhrzeit','Von','Nach','Personen','Fahrgast','Fahrer','Kunde'];
        csvContent += headers.join(';') + '\n';
      
        this.auftraege.forEach(eintrag => {
          const row = [
            eintrag.standort,
            eintrag.f_datum,
            eintrag.zeit,
            eintrag.von,
            eintrag.nach,
            eintrag.anzahl,
            eintrag.fahrgast,
            eintrag.fahrer,
            eintrag.kunde
          ];
          csvContent += row.join(';') + '\n';
        });
      
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', `tagesplan_${new Date().toISOString().slice(0, 10)}.csv`);
        document.body.appendChild(link); // nötig für Firefox
        link.click();
        document.body.removeChild(link);
    }

  }


// WEBPACK FOOTER //
// ./src/pages/auftraege/auftraege.ts